import { useEffect, useMemo, useState } from "react";
import { UNIVERSITY } from "./universityContent";

/**
 * Merges local fallbacks with live copy from the public WordPress site,
 * fetched via the Next.js proxy (`/api/public/university-site-content`) to avoid browser CORS.
 */
export function useUniversityContent(apiBase) {
  const [remote, setRemote] = useState(null);

  useEffect(() => {
    const base = (apiBase || "").replace(/\/$/, "");
    if (!base) return;
    let cancelled = false;
    fetch(`${base}/api/public/university-site-content`)
      .then((r) => (r.ok ? r.json() : null))
      .then((data) => {
        if (!cancelled && data?.site) setRemote(data);
      })
      .catch(() => {
        if (!cancelled) setRemote(null);
      });
    return () => {
      cancelled = true;
    };
  }, [apiBase]);

  return useMemo(() => {
    const base = UNIVERSITY;
    if (!remote?.site) {
      return { ...base, fromLiveSite: false };
    }

    const paragraphs = [];
    if (remote.pages?.about?.excerpt) {
      paragraphs.push(remote.pages.about.excerpt);
    }
    if (remote.pages?.welcome?.excerpt) {
      const w = remote.pages.welcome.excerpt.trim();
      if (w && !paragraphs.some((p) => p.trim() === w)) {
        paragraphs.push(w);
      }
    }
    if (paragraphs.length === 0) {
      paragraphs.push(...base.about.paragraphs);
    }

    return {
      ...base,
      fromLiveSite: true,
      shortName: remote.site.name || base.shortName,
      tagline: remote.site.tagline || base.tagline,
      mainWebsite: remote.site.url || base.mainWebsite,
      about: {
        ...base.about,
        paragraphs: paragraphs.slice(0, 4),
      },
    };
  }, [remote]);
}
